import actions from './actions';

let initState = {
    productDashboardLoader: false,
    productDashboardDetails: '',
    productDashboardError: '',

    productWiseAnalysisLoader: false,
    productWiseAnalysisDetails: '',
    productWiseAnalysisError: ''
};

export default function productDashboardReducer(state = initState, action) {
    switch (action.type) {
        case actions.PRODUCT_DASHBOARD_START: {
            return {
                ...state,
                productDashboardLoader: true
            };
        }
        case actions.PRODUCT_DASHBOARD_SUCCESS: {
            return {
                ...state,
                productDashboardLoader: false,
                productDashboardDetails: action.payload
            };
        }
        case actions.PRODUCT_DASHBOARD_FAILURE: {
            return {
                ...state,
                productDashboardLoader: false,
                productDashboardError: action.payload
            };
        }

        case actions.PRODUCT_WISE_ANALYSIS_START: {
            return {
                ...state,
                productWiseAnalysisLoader: true
            };
        }
        case actions.PRODUCT_WISE_ANALYSIS_SUCCESS: {
            return {
                ...state,
                productWiseAnalysisLoader: false,
                productWiseAnalysisDetails: action.payload
            };
        }
        case actions.PRODUCT_WISE_ANALYSIS_FAILURE: {
            return {
                ...state,
                productWiseAnalysisLoader: false,
                productWiseAnalysisError: action.payload
            };
        }
        default:
            return state;
    }
}

